// Left in place for backwards compatibility.  Import directly from @component/common-helpers instead.
module.exports = require('@component/common-helpers/src/helpers/Stringify');
